import { KnmErpActionsEnum } from '../enums/KnmErpActionsEnum';
import { IKnmErpState } from '../interfaces/IKnmErpState';
import { KnmErpAction } from '../types/KnmErpAction';

const initialState: IKnmErpState = {
  initialFormValues: undefined,
};

export function knmErpReducer(state: IKnmErpState = initialState, action: KnmErpAction): IKnmErpState {
  switch (action.type) {
    case KnmErpActionsEnum.KNM_ERP_SET_INITIAL_FORM_VALUES: {
      const { initialFormValues } = action.payload;

      return {
        ...state,
        initialFormValues: {
          ...state.initialFormValues,
          ...initialFormValues,
        },
      };
    }
    case KnmErpActionsEnum.KNM_ERP_RESET_INITIAL_FORM_VALUES: {
      return {
        ...state,
        initialFormValues: initialState.initialFormValues,
      };
    }
    default:
      return state;
  }
}
